// extracted by mini-css-extract-plugin
export default {"statisticsGroup":"StatisticsGroup-module__statisticsGroup--Uvami","statisticWrapper":"StatisticsGroup-module__statisticWrapper--RlrG8","body":"StatisticsGroup-module__body--aYtje"};